import UserProfile from "@/features/users/profile";

const User = () => {
  return <UserProfile />;
};

export default User;
